"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var specialtyApi = _interopRequireWildcard(require("@/api/specialtyApi.js"));
var _pageCache = require("@/utils/pageCache");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {},
  props: {},
  data: function data() {
    return {
      loading: false,
      constants: this.$constants,
      treeList: [],
      listPram: {},
      defaultImg: require('@/assets/imgs/moren.jpg')
    };
  },
  mounted: function mounted() {
    this.getAllList();
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return (0, _pageCache.refreshOnCacheReentry)(vm, vm.getAllList);
    });
  },
  methods: {
    getAllList: function getAllList() {
      var _this = this;
      this.treeList = [];
      specialtyApi.listCategroy(this.listPram).then(function (res) {
        _this.treeList = res || [];
      });
    },
    // 编辑专区
    updateSpec: function updateSpec(id) {
      this.$router.push({
        path: "/applet/specialty/editSpec/".concat(id ? id : 0)
      });
    },
    removeSpec: function removeSpec(id) {
      var _this2 = this;
      this.$confirm('确定删除当前数据', '提示').then(function (result) {
        specialtyApi.DelArticle({
          id: id
        }).then(function (data) {
          _this2.$message.success('删除数据成功');
          _this2.getAllList();
        });
      });
    }
  }
};